module.exports = __webpack_public_path__ + "static/media/main_logo.2c885af0.svg";